/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendSalaryDto } from '../../models/backend-salary-dto';
import { BackendSalaryRequestDto } from '../../models/backend-salary-request-dto';

export interface OpexesSalaryUpdate$FormData$Params {
  id: number;
  body: BackendSalaryRequestDto;
}

export function opexesSalaryUpdate$FormData(
  http: HttpClient,
  rootUrl: string,
  params: OpexesSalaryUpdate$FormData$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendSalaryDto>> {
  const rb = new RequestBuilder(rootUrl, opexesSalaryUpdate$FormData.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendSalaryDto>;
    }),
  );
}

opexesSalaryUpdate$FormData.PATH = '/api/opexes/salary/{id}/';
